//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <svg
    width="50px"
    height="50px"
    viewBox="0 0 50 50"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>close</title>
    <g
      id="go_close_icon"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        transform="translate(12.000000, 11.000000)"
        :style="{ fill: store.state.Style.themeColor }"
      >
        <g>
          <g>
            <path
              d="M13.5,0 C6.05609504,0 0,6.05609504 0,13.5 C0,20.943905 6.05609504,27 13.5,27 C20.943905,27 27,20.943905 27,13.5 C27,6.05609504 20.94375,0 13.5,0 Z M13.5,24.6856921 C7.33233471,24.6856921 2.31430785,19.6676653 2.31430785,13.5 C2.31430785,7.33233471 7.33233471,2.31430785 13.5,2.31430785 C19.6676653,2.31430785 24.6856921,7.33233471 24.6856921,13.5 C24.6856921,19.6676653 19.6675103,24.6856921 13.5,24.6856921 Z"
              id="Shape"
              fill-rule="nonzero"
            ></path>
            <path
              d="M18.7820432,8.21778455 C18.3249765,7.76073848 17.5838295,7.76073848 17.1275462,8.21778455 L13.5,11.8456366 L9.87245378,8.21778455 C9.41538703,7.76073848 8.6750235,7.76073848 8.21795675,8.21778455 C7.76089,8.67483061 7.76089,9.41516062 8.21795675,9.87220668 L11.845503,13.4999021 L8.21780006,17.1277541 C7.76073331,17.5848002 7.76073331,18.3251302 8.21780006,18.7821763 C8.44625509,19.010621 8.74569101,19.125 9.04512692,19.125 C9.34456283,19.125 9.64431213,19.0107777 9.87245378,18.7821763 L13.5,15.1544809 L17.1275462,18.7821763 C17.3560013,19.010621 17.6554372,19.125 17.9548731,19.125 C18.254309,19.125 18.5535882,19.0107777 18.7821999,18.7821763 C19.2392667,18.3251302 19.2392667,17.5848002 18.7821999,17.1277541 L15.154497,13.5000588 L18.7820432,9.87236336 C19.23911,9.4153173 19.23911,8.67483061 18.7820432,8.21778455 Z"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script setup>
import { useStore } from "vuex";
const store = useStore();
</script>
